<template>
  <main class="contact-wrapper" :class="{ 'contact-wrapper--expanded': hasSubmitted }">
    <h1 class="contact-wrapper__title">
      {{ contactTitle }}
    </h1>
    <div v-if="isSuccessful">
      <p class="contact-wrapper__submitted">
        {{ $t('CONTACT_US_SUBMITTED_CONTACT') }}
      </p>
      <ShButton :to="localePath('index')">
        {{ $t('CONTACT_US_BACK_TO_HOME_CTA') }}
      </ShButton>
    </div>
    <div v-else class="contact-wrapper__form">
      <ContactForm
        :isFormSaving="isSaving"
        :isFailed="submitFailed"
        :error="error"
        @save="submit"
      />
    </div>
  </main>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import ContactForm from '~/components/contact-us-form'
import RecaptchaV3 from '~/mixins/recaptcha'

const { mapActions } = createNamespacedHelpers('inquiries')

export default {
  components: {
    ContactForm
  },

  layout: 'public',

  head () {
    return {
      title: this.$t('META_TITLE_ENQUIRY'),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('META_DESCRIPTION_ENQUIRY') }
      ]
    }
  },

  mixins: [
    RecaptchaV3
  ],

  data () {
    return {
      hasSubmitted: false,
      isSaving: false,
      submitFailed: false,
      error: null
    }
  },

  computed: {
    contactTitle () {
      return this.hasSubmitted
        ? this.$t('CONTACT_US_SUBMITTED_HEADER_LABEL')
        : this.$t('CONTACT_US_HEADER_LABEL')
    },

    isSuccessful () {
      return !this.error && this.hasSubmitted
    }
  },

  async asyncData ({ store }) {
    try {
      await store.dispatch('inquiries/fetchInquiry')
    } catch (error) {
      console.log(error)
    }
  },

  methods: {
    ...mapActions(['createInquiry']),

    async submit (message) {
      const token = await this.getRecaptchaToken()

      this.isSaving = true
      this.error = null

      try {
        await this.createInquiry({ message, token })
      } catch (error) {
        this.error = error
      }

      this.hasSubmitted = true
      this.isSaving = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .contact-wrapper {
    margin: $space-090 $space-050;

    @include tablet {
      margin: $space-110 auto;
      width: 30%;
    }

    &--expanded {
      @include tablet {
        width: 50%;
      }
    }

    &__title {
      @include font('080');
      margin-bottom: $space-050;

      @include tablet {
        @include font('090');

        margin-bottom: $space-070;
      }
    }

    &__submitted {
      @include font('070');
      margin-bottom: $space-050;

      @include tablet {
        @include font('070');

        margin-bottom: $space-070;
      }
    }
  }
</style>
